// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.big-box {
  border: 2px solid #333;
  padding: 20px;
  background-color: #f0f0f0;
  border-radius: 10px;
  box-shadow: 2px 2px 5px #888;
  text-align: center;
}

body {
  overflow-x: hidden;
}

.logo {
  width: 100px;
  margin-right: 100px;
}

.top-menu-wrap {
  display: flex;
  align-items: center;
  padding: 20px 10px;
}

.user-name {
  display: flex;
  align-items: center;
}

.user-details {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

.user-name p {
  display: flex;
  align-items: center;
}

.user-name span {
  width: 40px;
  height: 40px;
  background: red;
  border-radius: 50%;
  display: block;
  margin-right: 10px;
}

.dashbored-wrap {
  display: flex;
  width: 100%;
  height: 100vh;
  background: var(--fc-bg, #fff);
  /* background: red; */
}

.top-menu-wrap {
  width: 100%;
  height: 100px;
  background: var(--fc-bg, #fff);
}

.dash-details {
  width: 100%;
  display: flex;
  max-height: 100vh;
  /* background: green; */
}

.detail-list {
  max-width: 250px;
  width: 100%;
  padding: 20px 10px;
  background-color: #efeeee;
  color: #212529;
  position: fixed;
  top: calc(var(--app-header) + 24px);
  height: calc(100vh - 120px);
}

ul {
  list-style: none;
  padding: 0px;
  margin: 0px;
}

p {
  margin-bottom: 10px;
}

ul li {
  margin-bottom: 10px;
  height: 40px;
  padding: 0px 10px;
  position: relative;
  z-index: 1;
  color: #212529;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  transition: width 0.3s ease 0s, left 0.3s ease 0s;
}

ul li:before {
  bottom: 0;
  content: "";
  display: block;
  height: 100%;
  left: 0px;
  position: absolute;
  background: #fff;
  transition: width 0.3s ease 0s, left 0.3s ease 0s;
  width: 0%;
  z-index: -1;
}

ul li:hover {
  color: #000;
}

ul li:hover:before {
  /* background: #fff;
    color: #212529; */
  width: 100%;
}

.table-bordered {
  border: 0px;
}

.detail-description {
  /* width: 100%; */
  height: 100%;
  padding: 0px;
  width: calc(100% - 250px);
  height: 100%;
  padding: 0px;
  width: 100%;
  left: 270px;
  top: 120px;
  /* background: purple; */
}

.followers-tag {
  display: flex;
  position: relative;
  z-index: 1;
}

h3 {
  position: relative;
  z-index: 3;
  color: #fff;
  font-weight: normal;
}

.com-record {
  width: 100%;
  height: auto;
  position: relative;
  z-index: 0;
  padding: 20px 30px 30px;
}
.com-record .followers-tag .box .text p.number {
  font-family: Arial !important;
}

.com-record:after {
  content: "";
  width: 100%;
  height: 60%;
  /* background: gray; */
  top: 0px;
  position: absolute;
  left: 0px;
  z-index: 0;
  background: #5ea1d8;
}

.ico-box {
  width: 40px;
  height: 40px;
  background: cyan;
}

.table-wrap {
  padding: 30px;
  /* width:calc(100% - 76px); */
}

.box {
  width: auto;
  padding: 5px 10px;
  background: #fff;
  margin-right: 20px;
  border: 1px solid #ddd;
  border-radius: 10px;
  display: flex;
  box-shadow: 1px 1px 25px rgba(0, 0, 0, 0.1607843137);
}

.filter-ico li {
  width: 40px;
}

.filter-ico li i {
  color: #000;
}

.text {
  padding-right: 10px;
}

.table-parent {
  overflow-x: scroll;
  margin-top: -8px;
  overflow-y: auto;
}

table {
  margin-bottom: 20px;
  border-collapse: collapse;
  width: 100%;
  background: white;
  border-radius: 0 0 8px 8px;
  overflow: hidden;
}

th,
td {
  border: none;
  color: #333;
  padding: 16px;
  min-width: 100px;
  font-family: "Raleway";
  vertical-align: middle;
}

th {
  background-color: #f5f5f5;
  font-weight: 600;
  color: #333;
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 0.5px;
  padding: 16px;
  border-bottom: 2px solid #e0e0e0;
}

td {
  padding: 16px;
  border-bottom: 1px solid #e0e0e0;
  vertical-align: middle;
}

td[scope=row] {
  position: relative;
}

.inner {
  width: 100%;
  margin-bottom: 0px;
}
.inner td {
  padding: 5px;
  border: 0px;
}
.inner td:first-child {
  width: 30px;
}

tbody tr {
  cursor: pointer;
  transition: background-color 0.2s;
}
tbody tr:hover {
  background-color: #f9f9f9;
}
tbody tr:hover td {
  color: #333;
}
tbody tr:last-child td {
  border-bottom: none;
}

.filter {
  display: flex;
  align-items: center;
  margin-bottom: 0px;
  border: 1px solid #ddd;
  border-bottom: 0px;
  padding: 10px 10px;
}

.filter-title {
  flex: 1;
}

.filter ul {
  display: flex;
}

.filter-bar {
  display: flex;
}

.search-container {
  position: relative;
}

.search-input {
  width: 400px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  position: relative;
}

.search-input + i {
  position: absolute;
  right: 20px;
  top: 37%;
}

.search-icon {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}

.chekbox-image {
  display: flex;
}
.chekbox-image td:first-child {
  width: unset;
  flex: 1;
  min-width: 150px;
  display: flex;
  align-items: flex-start;
}
.chekbox-image td:first-child span {
  padding-left: 13px;
}
.chekbox-image td:last-child {
  min-width: unset;
  width: 40px;
  display: flex;
  align-items: flex-start;
}

.image-sec img {
  max-width: 100%;
  max-height: 80px;
  width: 100%;
  object-fit: cover;
}

.mobile-design {
  display: none;
}

@media (max-width: 992px) {
  .detail-list {
    display: none;
  }
  .detail-description {
    width: 100%;
    left: 0px;
    padding: 0px 15px;
  }
  .followers-tag {
    flex-wrap: wrap;
  }
  .followers-tag .box {
    margin: 10px;
    width: 100%;
  }
  .followers-tag .box .text {
    flex: 1;
  }
  .com-record {
    padding: 15px;
  }
  .com-record:after {
    height: 130px;
  }
  .search-container .search-input {
    width: 100%;
  }
  .top-menu-wrap {
    display: none;
  }
  .table-wrap .table-parent {
    display: none;
  }
  .mobile-design {
    padding: 20px 10px;
    background: lightblue;
    display: block;
  }
  .mobile-design .tile {
    background: #fff;
    padding: 10px;
  }
  .mobile-design .tile > div {
    border-bottom: 1px solid #ddd;
  }
  .mobile-design .tile p {
    color: #5ea1d8 !important;
  }
  .mobile-design .tile p.bold {
    font-weight: 700 !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  .mobile-design .tile .main-title {
    display: flex;
    align-items: center;
    background: #5ea1d8;
    padding: 10px;
    margin-bottom: 10px;
  }
  .mobile-design .tile .main-title h3 {
    margin-bottom: 0px !important;
    color: #fff !important;
  }
  .mobile-design .first-tile div {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  .mobile-design .first-tile div span {
    display: flex;
    align-items: center;
  }
  .mobile-design .first-tile input {
    position: relative;
    margin: 0px 10px 0px 0px;
    width: 20px;
    height: 20px;
  }
  .mobile-design .first-tile .img {
    display: flex;
    align-items: flex-start;
  }
  .mobile-design .first-tile .img .bundle {
    width: 30px;
    margin-right: 10px;
    height: 30px;
  }
  .mobile-design .first-tile .img img {
    width: 100%;
    max-height: 80px;
    object-fit: cover;
  }
  .mobile-design .common-tile {
    display: flex;
  }
  .mobile-design .common-tile .title-tile {
    flex: 1;
    padding: 3px;
  }
}
.pie-chart-canvas {
  width: 400px;
  height: 400px;
}

.mat-mdc-tab-list {
  margin-bottom: 10px;
}

/* Assuming each chart component has a class name of 'chart-container' */
.row {
  grid-template-columns: auto auto; /* Use flexbox to align items in a row */
  overflow-x: hidden !important;
}

.chart-container {
  margin: 15px;
  height: 25vh;
  width: 50vh;
  flex: 1;
}

/* new setting common design starts here*/
.setting-dashboard {
  padding: 0;
  height: auto;
  position: relative;
  margin-top: 0;
  background: var(--fc-bg, #fff);
}

.dashbored-wrap {
  padding-left: 10px;
  margin-top: 5 0px;
}

.setting-dashboard .row {
  flex-direction: row;
  height: 100%;
  margin: 0px;
}

.setting-dashboard .left-user {
  background: #5ea1d8;
  position: relative;
  padding: 0 0 0 30px;
  position: fixed;
  top: calc(var(--app-header) + 24px);
  height: calc(100vh - 100px);
  z-index: 3;
}

.collapse-btn {
  position: absolute;
  width: 25px;
  height: 25px;
  background: #5ea1d8;
  border-radius: 50%;
  right: -12.5px;
  top: 26px;
  border: 2px solid #fff;
  box-shadow: 0 0 3px #171717;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  transform: rotate(180deg);
}

.setting-dashboard .left-user .dash-title {
  position: unset;
  width: 100%;
}

.setting-dashboard .dash-title {
  height: 80px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  color: #fff;
  position: fixed;
  z-index: 2;
  top: 120px;
}

.setting-dashboard .dash-title h6,
.setting-dashboard .dash-title .h6 {
  display: flex;
  align-items: center;
  font-weight: 500 !important;
  color: #fff !important;
}

.setting-dashboard .dash-title h6 span,
.setting-dashboard .dash-title .h6 span {
  width: auto !important;
  font-size: 20px;
  margin-right: 10px;
}

.setting-dashboard.search-add .dash-elemenet {
  height: calc(100vh - 180px);
}
.setting-dashboard.search-add .dash-elemenet ul {
  padding: 0px;
  margin: 0px;
  width: 100%;
  list-style-type: none;
}
.setting-dashboard.search-add .dash-elemenet ul li {
  height: 40px;
  margin-bottom: 10px;
  position: relative;
  display: flex;
  align-items: center;
  transition: all 0.5s linear;
  padding-left: 10px;
}
.setting-dashboard.search-add .dash-elemenet ul li:after {
  bottom: 0;
  content: "";
  display: block;
  height: 1px;
  height: 100%;
  left: 0%;
  position: absolute;
  background: #fff;
  background: #1d67a3;
  transition: all 0.5s linear;
  width: 0;
  z-index: -1;
}
.setting-dashboard.search-add .dash-elemenet ul li:hover:after, .setting-dashboard.search-add .dash-elemenet ul li:active:after, .setting-dashboard.search-add .dash-elemenet ul li:focus:after {
  content: "";
  width: 100%;
  left: 0;
  transition: all 0.5s linear;
}

.setting-dashboard .dash-elemenet {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  margin-top: 1rem;
  height: calc(100vh - 220px);
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 20px;
}

.setting-dashboard .dash-elemenet > div {
  width: 100%;
  line-height: 26px;
  margin-bottom: 10px;
  font-size: 13px;
  font-weight: 400;
  cursor: pointer;
  color: #fff;
  transition: all 0.5slinear;
  position: relative;
  padding-bottom: 0;
  z-index: 2;
  min-height: 40px;
  display: flex;
  align-items: center;
}

.left-user .selected-item {
  background: #1d67a3 !important;
  padding-left: 10px;
}

.setting-dashboard .left-user .dash-elemenet > div span {
  width: auto !important;
  font-size: 20px;
  margin-right: 10px;
}

/*right section*/
.setting-dashboard .submission-field {
  left: 16.666667%;
  padding-right: 0;
  position: fixed;
  position: absolute;
  top: 0px;
  width: 83.333333%;
  padding-left: 0px;
  border-left: 1px solid #fff;
}

.setting-dashboard .submission-field .hamburger {
  width: 100%;
  background: #985ce1;
  display: flex;
  position: relative;
}

.setting-dashboard .submission-field .hamburger .dash-title {
  padding-left: 15px;
  background: #5ea1d8;
  display: flex;
  color: #fff;
  width: 83.333333%;
}

.scroll-div {
  position: sticky;
  top: var(--app-header) !important; /* match landing page */
  margin-top: 0 !important;
  width: 100%;
  padding-bottom: 20px;
}

.scroll-div .dash-text {
  padding: 10px 15px 0; /* match landing page padding */
}

.mat-mdc-tab-group {
  display: flex;
  flex-direction: column;
  max-width: 100%;
}

.setting-dashboard .dash-elemenet > div:after {
  bottom: 0;
  content: "";
  display: block;
  height: 1px;
  height: 100%;
  left: 0%;
  position: absolute;
  background: #fff;
  background: #6322b2;
  transition: width 0.5sease 0s, left 0.5sease 0s;
  width: 0;
  z-index: -1;
}

.setting-dashboard .dash-elemenet > div span:last-child {
  font-size: 12px !important;
}

@media (max-width: 767px) {
  .scroll-div {
    margin-top: 0 !important;
    padding-top: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
    top: 0 !important;
  }
  .mob-menu {
    background: #5d9fd5 !important;
    position: sticky;
    top: var(--app-header, 56px);
    z-index: 1500;
    width: 100%;
    display: block !important;
  }
  .navbar {
    justify-content: flex-start;
    margin-bottom: 0px;
  }
  .mob-menu button {
    background: #5d9fd5 !important;
    margin-bottom: 0 !important;
    color: #fff;
    font-size: 14px;
    padding: 10px 5px;
    text-transform: capitalize;
    border: 1px solid #fff !important;
    box-shadow: none !important;
    display: flex !important;
    align-items: center;
  }
}
.setting-dashboard {
  padding: 0;
  position: relative;
  margin-top: 0;
  background: var(--fc-bg, #fff);
}
.setting-dashboard .row {
  flex-direction: row;
  height: 100%;
  margin: 0px;
}
.setting-dashboard .left-user {
  background: #5ea1d8;
  position: relative;
  padding: 0 0 0 30px;
  position: fixed;
  top: 120px;
  height: calc(100vh - 100px);
  z-index: 3;
}
.setting-dashboard .left-user .collapse-btn {
  position: absolute;
  width: 25px;
  height: 25px;
  background: #5ea1d8;
  border-radius: 50%;
  right: -12.5px;
  top: 26px;
  border: 2px solid #fff;
  box-shadow: 0 0 3px #171717;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  transform: rotate(180deg);
}
.setting-dashboard .left-user .dash-elemenet {
  height: calc(100vh - 180px);
}
.setting-dashboard .left-user .dash-elemenet ul {
  padding: 0px;
  margin: 0px;
  width: 100%;
  list-style-type: none;
}
.setting-dashboard .left-user .dash-elemenet ul li {
  height: 40px;
  margin-bottom: 10px;
  position: relative;
  display: flex;
  align-items: center;
  transition: all 0.5s linear;
  padding-left: 10px;
}
.setting-dashboard .left-user .dash-elemenet ul li:after {
  bottom: 0;
  content: "";
  display: block;
  height: 1px;
  height: 100%;
  left: 0%;
  position: absolute;
  background: #fff;
  background: #1d67a3;
  transition: all 0.5s linear;
  width: 0;
  z-index: -1;
}
.setting-dashboard .left-user .dash-elemenet ul li:hover:after, .setting-dashboard .left-user .dash-elemenet ul li:active:after, .setting-dashboard .left-user .dash-elemenet ul li:focus:after {
  content: "";
  width: 100%;
  left: 0;
  transition: all 0.5s linear;
}

.dashbored-wrap {
  padding-left: 10px;
  margin-top: 0;
}

.setting-dashboard .left-user .dash-title {
  position: unset;
  width: 100%;
}

.setting-dashboard .dash-title {
  height: 80px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  color: #fff;
  position: fixed;
  z-index: 2;
  top: 120px;
}

.setting-dashboard .dash-title h6,
.setting-dashboard .dash-title .h6 {
  display: flex;
  align-items: center;
  font-weight: 500 !important;
  color: #fff !important;
}

.setting-dashboard .dash-title h6 span,
.setting-dashboard .dash-title .h6 span {
  width: auto !important;
  font-size: 20px;
  margin-right: 10px;
}

.setting-dashboard .dash-elemenet {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  margin-top: 1rem;
  height: calc(100vh - 220px);
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 20px;
}

.setting-dashboard .dash-elemenet > div {
  width: 100%;
  line-height: 26px;
  margin-bottom: 10px;
  font-size: 13px;
  font-weight: 400;
  cursor: pointer;
  color: #fff;
  transition: all 0.5slinear;
  position: relative;
  padding-bottom: 0;
  z-index: 2;
  min-height: 40px;
  display: flex;
  align-items: center;
}

.left-user .selected-item {
  background: #1d67a3 !important;
  padding-left: 10px;
}

.setting-dashboard .left-user .dash-elemenet > div span {
  width: auto !important;
  font-size: 20px;
  margin-right: 10px;
}

/*right section*/
.setting-dashboard .submission-field {
  left: 16.666667%;
  padding-right: 0;
  position: fixed;
  position: absolute;
  top: 0px;
  width: 83.333333%;
  padding-left: 0px;
  border-left: 1px solid #fff;
}

.setting-dashboard .submission-field .hamburger {
  width: 100%;
  background: #985ce1;
  display: flex;
  position: relative;
}

.setting-dashboard .submission-field .hamburger .dash-title {
  padding-left: 15px;
  background: #5ea1d8;
  display: flex;
  color: #fff;
  width: 83.333333%;
}

.scroll-div {
  position: sticky;
  top: var(--app-header) !important; /* match landing page */
  margin-top: 0 !important;
  width: 100%;
  padding-bottom: 20px;
}
.scroll-div .dash-text {
  padding: 10px 15px 0; /* match landing page padding */
}

.mat-mdc-tab-group {
  display: flex;
  flex-direction: column;
  max-width: 100%;
}

.setting-dashboard .dash-elemenet > div:after {
  bottom: 0;
  content: "";
  display: block;
  height: 1px;
  height: 100%;
  left: 0%;
  position: absolute;
  background: #fff;
  background: #6322b2;
  transition: width 0.5sease 0s, left 0.5sease 0s;
  width: 0;
  z-index: -1;
}

.setting-dashboard .dash-elemenet > div span:last-child {
  font-size: 12px !important;
}

@media (max-width: 767px) {
  .scroll-div {
    margin-top: 0 !important;
    padding-top: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
    top: 0 !important;
  }
  .mob-menu {
    background: #5d9fd5 !important;
    position: sticky;
    top: var(--app-header, 56px);
    z-index: 1500;
    width: 100%;
    display: block !important;
  }
  .navbar {
    justify-content: flex-start;
    margin-bottom: 0px;
  }
  .mob-menu button {
    background: #5d9fd5 !important;
    margin-bottom: 0 !important;
    color: #fff;
    font-size: 14px;
    padding: 10px 5px;
    text-transform: capitalize;
    border: 1px solid #fff !important;
    box-shadow: none !important;
    display: flex !important;
    align-items: center;
  }
  .setting-dashboard .left-user {
    width: 59vw;
    position: fixed;
    top: calc(var(--app-header, 56px) + 48px);
    height: calc(100vh - (var(--app-header, 56px) + 48px));
    padding-left: 10px;
    left: -59vw;
    transition: left 0.5s linear;
    display: block !important;
    z-index: 1600;
  }
  .setting-dashboard .show-menu .left-user {
    left: 0px;
    transition: left 0.5s linear;
  }
  .setting-dashboard .submission-field {
    width: 100%;
    left: 0px;
  }
  .dashbored-wrap .table-wrap {
    padding: 0px;
  }
  .setting-dashboard .submission-field .hamburger .dash-title {
    width: 100%;
    top: calc(var(--app-header, 56px) + 48px);
    height: 40px;
  }
  .setting-dashboard .left-user .dash-title {
    display: none;
  }
  .setting-dashboard .left-user .collapse-btn {
    display: none;
  }
  .dashbored-wrap {
    margin-top: 10px !important;
  }
  .dashbored-wrap .mobile-design {
    padding: 20px;
  }
  .dashbored-wrap .com-record:after {
    height: 133px;
  }
}
label[for=timePeriod] {
  display: inline-block;
  margin: 16px 8px 16px 0;
  line-height: 40px;
  vertical-align: middle;
}

#timePeriod {
  height: 40px;
  min-width: 160px;
  box-sizing: border-box;
  margin: 16px 0;
  padding: 0 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: #fff;
  font: inherit;
  font-size: 14px;
  color: #333;
  vertical-align: middle;
}

.view-toggle {
  display: flex;
  align-items: center;
}
.view-toggle button {
  color: #5ea1d8;
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
  padding: 0 !important;
  width: 40px !important;
  height: 40px !important;
  min-width: 40px !important;
  min-height: 40px !important;
  border-radius: 50% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.view-toggle button:hover {
  background-color: rgba(94, 161, 216, 0.1) !important;
}
.view-toggle button:focus {
  outline: none !important;
  background-color: rgba(94, 161, 216, 0.18) !important;
}
.view-toggle button mat-icon {
  font-size: 22px !important;
  width: 22px !important;
  height: 22px !important;
  line-height: 22px !important;
}

.links-list-card {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 20px;
}
.links-list-card .no-links {
  text-align: center;
  padding: 60px 20px;
}
.links-list-card .no-links mat-icon {
  font-size: 64px;
  width: 64px;
  height: 64px;
  color: #ccc;
  margin-bottom: 16px;
}
.links-list-card .no-links h3 {
  margin: 0 0 8px 0;
  color: #666;
}
.links-list-card .no-links p {
  margin: 0;
  color: #999;
}
.links-list-card .link-card-modern {
  background-color: #fff;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
  overflow: hidden;
  transition: all 0.3s ease;
  box-sizing: border-box;
}
.links-list-card .link-card-modern:hover {
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.12);
}
.links-list-card .link-card-modern .card-content {
  padding: 24px;
}
.links-list-card .link-card-modern .link-header-modern {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  gap: 16px;
}
.links-list-card .link-card-modern .link-header-modern .link-title-modern {
  margin: 0;
  font-weight: 700;
  font-size: 18px;
  color: #0f172a;
  flex: 1;
}
.links-list-card .link-card-modern .link-header-modern .click-count-badge {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 600;
  background-color: #dbeafe;
  color: #2563eb;
  white-space: nowrap;
}
.links-list-card .link-card-modern .link-content-modern .link-field {
  margin-bottom: 16px;
}
.links-list-card .link-card-modern .link-content-modern .link-field label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #94a3b8;
  margin-bottom: 8px;
}
.links-list-card .link-card-modern .link-content-modern .link-field p {
  margin: 0;
  color: #334155;
  line-height: 1.6;
  font-size: 15px;
}
.links-list-card .link-card-modern .link-content-modern .link-field .link-url-modern {
  color: #5ea1d8;
  text-decoration: none;
  font-weight: 500;
  word-break: break-all;
}
.links-list-card .link-card-modern .link-content-modern .link-field .link-url-modern:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .links-list-card .link-card-modern {
    border-radius: 12px;
  }
  .links-list-card .link-card-modern .card-content {
    padding: 16px;
  }
  .links-list-card .link-card-modern .link-header-modern {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
}
:host-context(body.theme-dark) .dashbored-wrap,
:host-context(body.theme-dark) .setting-dashboard,
:host-context(body.theme-dark) .scroll-div,
:host-context(body.theme-dark) .com-record,
:host-context(body.theme-dark) .table-wrap,
:host-context(body.theme-dark) .filter,
:host-context(body.theme-dark) .search-input,
:host-context(body.theme-dark) .detail-list,
:host-context(body.theme-dark) .detail-description,
:host-context(body.theme-dark) .big-box {
  background: #111827 !important;
  background-color: #111827 !important;
  color: #e5e7eb !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) #timePeriod {
  background-color: #0f172a;
  color: #e5e7eb;
  border-color: rgba(148, 163, 184, 0.3);
}
:host-context(body.theme-dark) table, :host-context(body.theme-dark) thead, :host-context(body.theme-dark) tbody, :host-context(body.theme-dark) tr, :host-context(body.theme-dark) td {
  background: #111827 !important;
  background-color: #111827 !important;
  color: #e5e7eb !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) th {
  background: #0f172a !important;
  background-color: #0f172a !important;
  color: #94a3b8 !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) tbody tr:hover {
  background: #1f2937 !important;
}
:host-context(body.theme-dark) tbody tr.no-data-row,
:host-context(body.theme-dark) tbody tr.no-data-row:hover {
  background: #111827 !important;
}
:host-context(body.theme-dark) tbody tr.no-data-row td,
:host-context(body.theme-dark) tbody tr.no-data-row:hover td {
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .box {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) p, :host-context(body.theme-dark) span:not(.material-icons):not(.status-badge-modern):not([class*=badge]):not([class*=status-]), :host-context(body.theme-dark) label, :host-context(body.theme-dark) li, :host-context(body.theme-dark) h1, :host-context(body.theme-dark) h2, :host-context(body.theme-dark) h3, :host-context(body.theme-dark) h4, :host-context(body.theme-dark) h5, :host-context(body.theme-dark) h6, :host-context(body.theme-dark) i, :host-context(body.theme-dark) b {
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .mobile-design {
  background: #0f172a !important;
}
:host-context(body.theme-dark) .mobile-design .tile {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) .links-list-card .link-card-modern {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) .links-list-card .link-card-modern .link-title-modern {
  color: #f1f5f9 !important;
}
:host-context(body.theme-dark) .links-list-card .link-card-modern .link-field p {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .links-list-card .link-card-modern .link-field label {
  color: #64748b !important;
}
:host-context(body.theme-dark) .links-list-card .link-card-modern .click-count-badge {
  background: #1e3a5f !important;
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .skeleton-text,
:host-context(body.theme-dark) .skeleton-checkbox,
:host-context(body.theme-dark) .skeleton-icon,
:host-context(body.theme-dark) .skeleton-image,
:host-context(body.theme-dark) .skeleton-price {
  background: linear-gradient(90deg, #1f2937 25%, #374151 50%, #1f2937 75%) !important;
  background-size: 200% 100% !important;
}

body.theme-dark .dashbored-wrap,
body.theme-dark .setting-dashboard {
  background: var(--fc-bg) !important;
  color: var(--fc-fg) !important;
}

body.theme-dark .dashbored-wrap .top-menu-wrap,
body.theme-dark .dashbored-wrap .box,
body.theme-dark .dashbored-wrap .card,
body.theme-dark .dashbored-wrap .mat-mdc-card,
body.theme-dark .dashbored-wrap .tile,
body.theme-dark .dashbored-wrap .com-record,
body.theme-dark .dashbored-wrap .table-wrap,
body.theme-dark .dashbored-wrap .detail-list,
body.theme-dark .dashbored-wrap .filter,
body.theme-dark .dashbored-wrap .search-input,
body.theme-dark .dashbored-wrap .tab-content,
body.theme-dark .dashbored-wrap .followers-tag .box {
  background: var(--fc-bg2) !important;
  color: var(--fc-fg) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .dashbored-wrap table,
body.theme-dark .dashbored-wrap thead,
body.theme-dark .dashbored-wrap tbody,
body.theme-dark .dashbored-wrap tr,
body.theme-dark .dashbored-wrap td {
  background: var(--fc-bg) !important;
  color: var(--fc-fg) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .dashbored-wrap th {
  background: var(--fc-bg-head) !important;
  color: var(--fc-fg) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .dashbored-wrap tbody tr:hover {
  background: var(--fc-bg-hover) !important;
}

body.theme-dark .dashbored-wrap input,
body.theme-dark .dashbored-wrap select,
body.theme-dark .dashbored-wrap textarea {
  background: #0f172a !important;
  color: var(--fc-fg) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .dashbored-wrap .mobile-design {
  background: var(--fc-bg) !important;
  color: var(--fc-fg) !important;
}

body.theme-dark .dashbored-wrap .mobile-design .tile {
  background: var(--fc-bg2) !important;
  color: var(--fc-fg) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .dashbored-wrap [class*=skeleton-] {
  background: var(--fc-skel) !important;
  color: transparent !important;
}

body.theme-dark .dashbored-wrap p,
body.theme-dark .dashbored-wrap label,
body.theme-dark .dashbored-wrap li,
body.theme-dark .dashbored-wrap h1,
body.theme-dark .dashbored-wrap h2,
body.theme-dark .dashbored-wrap h3,
body.theme-dark .dashbored-wrap h4,
body.theme-dark .dashbored-wrap h5,
body.theme-dark .dashbored-wrap h6 {
  color: var(--fc-fg) !important;
}

body.theme-dark .dashbored-wrap span:not(.material-icons):not(.badge):not([class*=status]) {
  color: var(--fc-fg) !important;
}

/* ── Override global white-background globals (.table-card, .fc-table, .filter-section) ── */
body.theme-dark .table-card {
  background: #1f2937 !important;
  background-color: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4) !important;
}

body.theme-dark .fc-table {
  background: #1f2937 !important;
  background-color: #1f2937 !important;
}

body.theme-dark .fc-table thead th {
  background-color: #0f172a !important;
  background: #0f172a !important;
  color: #94a3b8 !important;
  border-bottom-color: rgba(148, 163, 184, 0.25) !important;
  border-right-color: rgba(148, 163, 184, 0.15) !important;
}

body.theme-dark .fc-table tbody td {
  background-color: #1f2937 !important;
  color: #e2e8f0 !important;
  border-top-color: rgba(148, 163, 184, 0.15) !important;
  border-right-color: rgba(148, 163, 184, 0.1) !important;
}

body.theme-dark .fc-table tbody tr:nth-child(even) td {
  background-color: #253347 !important;
}

body.theme-dark .fc-table tbody tr:hover td {
  background-color: #374151 !important;
  color: #f1f5f9 !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}

body.theme-dark .filter-section {
  background: #1f2937 !important;
  background-color: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
}

body.theme-dark .filter-section label {
  color: #94a3b8 !important;
}

body.theme-dark .filter-section select,
body.theme-dark .filter-section input {
  background: #0f172a !important;
  background-color: #0f172a !important;
  color: #e2e8f0 !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}

/* ── Dark scrollbars and overflow area fix ── */
body.theme-dark .table-parent {
  background: #1f2937 !important;
  background-color: #1f2937 !important;
}

body.theme-dark .table-parent::-webkit-scrollbar,
body.theme-dark .table-card::-webkit-scrollbar {
  background: #111827;
  width: 6px;
  height: 6px;
}

body.theme-dark .table-parent::-webkit-scrollbar-track,
body.theme-dark .table-card::-webkit-scrollbar-track {
  background: #1f2937;
  border-radius: 4px;
}

body.theme-dark .table-parent::-webkit-scrollbar-thumb,
body.theme-dark .table-card::-webkit-scrollbar-thumb {
  background: #374151;
  border-radius: 4px;
}

body.theme-dark .table-parent::-webkit-scrollbar-thumb:hover,
body.theme-dark .table-card::-webkit-scrollbar-thumb:hover {
  background: #4b5563;
}

body.theme-dark .table-parent::-webkit-scrollbar-corner,
body.theme-dark .table-card::-webkit-scrollbar-corner {
  background: #111827;
}

/* ── Click-count badge dark mode ── */
body.theme-dark .click-count-badge {
  background: #1e3a5f !important;
  color: #93c5fd !important;
  border-color: rgba(147, 197, 253, 0.3) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/user-dashboard/content-analytics/content-analytics.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,sBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,4BAAA;EACA,kBAAA;AAEJ;;AACE;EACE,kBAAA;AAEJ;;AACE;EACE,YAAA;EACA,mBAAA;AAEJ;;AACE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AAEJ;;AACE;EACE,aAAA;EACA,mBAAA;AAEJ;;AACE;EACE,OAAA;EACA,aAAA;EACA,yBAAA;AAEJ;;AACE;EACE,aAAA;EACA,mBAAA;AAEJ;;AACE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AAEJ;;AACE;EACE,aAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,qBAAA;AAEJ;;AACE;EACE,WAAA;EACA,aAAA;EAEA,8BAAA;AACJ;;AAEE;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EAEA,uBAAA;AAAJ;;AAGE;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,mCAAA;EACA,2BAAA;AAAJ;;AAGE;EACE,gBAAA;EACA,YAAA;EACA,WAAA;AAAJ;;AAGE;EACE,mBAAA;AAAJ;;AAGE;EACE,mBAAA;EACA,YAAA;EAEA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,iDAAA;AADJ;;AAIE;EACE,SAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;EACA,SAAA;EACA,WAAA;AADJ;;AAIE;EACE,WAAA;AADJ;;AAIE;EACE;qBAAA;EAEA,WAAA;AADJ;;AAIE;EACE,WAAA;AADJ;;AAIE;EACE,iBAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EAEA,WAAA;EACA,UAAA;EACA,wBAAA;AAFJ;;AAKE;EACE,aAAA;EACA,kBAAA;EACA,UAAA;AAFJ;;AAKE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;AAFJ;;AAKE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,uBAAA;AAFJ;AAOU;EACE,6BAAA;AALZ;;AAYE;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;AATJ;;AAYE;EACE,WAAA;EACA,YAAA;EACA,gBAAA;AATJ;;AAYE;EACE,aAAA;EACA,6BAAA;AATJ;;AAYE;EACE,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,oDAAA;AATJ;;AAYE;EACE,WAAA;AATJ;;AAYE;EACE,WAAA;AATJ;;AAYE;EACE,mBAAA;AATJ;;AAYE;EACE,kBAAA;EACA,gBAAA;EAEA,gBAAA;AAVJ;;AAaE;EACE,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,0BAAA;EACA,gBAAA;AAVJ;;AAaE;;EAEE,YAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;AAVJ;;AAaE;EACE,yBAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,eAAA;EACA,qBAAA;EACA,aAAA;EACA,gCAAA;AAVJ;;AAaE;EACE,aAAA;EACA,gCAAA;EACA,sBAAA;AAVJ;;AAaE;EACE,kBAAA;AAVJ;;AAaE;EACE,WAAA;EACA,kBAAA;AAVJ;AAYI;EACE,YAAA;EACA,WAAA;AAVN;AAYM;EACE,WAAA;AAVR;;AAeE;EACE,eAAA;EACA,iCAAA;AAZJ;AAiBI;EACE,yBAAA;AAfN;AAiBM;EACE,WAAA;AAfR;AAkBI;EACE,mBAAA;AAhBN;;AA4BE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;AAzBJ;;AA4BE;EACE,OAAA;AAzBJ;;AA4BE;EACE,aAAA;AAzBJ;;AA4BE;EACE,aAAA;AAzBJ;;AA4BE;EACE,kBAAA;AAzBJ;;AA4BE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;AAzBJ;;AA4BE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;AAzBJ;;AA4BE;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;AAzBJ;;AA4BE;EACE,aAAA;AAzBJ;AA4BM;EACE,YAAA;EACA,OAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;AA1BR;AA4BQ;EACE,kBAAA;AA1BV;AA8BM;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;AA5BR;;AAkCI;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;AA/BN;;AAyCE;EACE,aAAA;AAtCJ;;AAyCE;EACE;IACE,aAAA;EAtCJ;EAyCE;IACE,WAAA;IACA,SAAA;IACA,iBAAA;EAvCJ;EA0CE;IACE,eAAA;EAxCJ;EA0CI;IACE,YAAA;IACA,WAAA;EAxCN;EA0CM;IACE,OAAA;EAxCR;EA6CE;IACE,aAAA;EA3CJ;EA6CI;IACE,aAAA;EA3CN;EAoDI;IACE,WAAA;EAlDN;EAsDE;IACE,aAAA;EApDJ;EAwDI;IACE,aAAA;EAtDN;EA0DE;IACE,kBAAA;IACA,qBAAA;IACA,cAAA;EAxDJ;EA0DI;IACE,gBAAA;IACA,aAAA;EAxDN;EA0DM;IACE,6BAAA;EAxDR;EA2DM;IACE,yBAAA;EAzDR;EA4DM;IACE,2BAAA;IACA,oDAAA;EA1DR;EA6DM;IACE,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,aAAA;IACA,mBAAA;EA3DR;EA6DQ;IACE,6BAAA;IACA,sBAAA;EA3DV;EAkEM;IACE,aAAA;IACA,mBAAA;IACA,mBAAA;EAhER;EAkEQ;IACE,aAAA;IACA,mBAAA;EAhEV;EAoEM;IACE,kBAAA;IACA,wBAAA;IACA,WAAA;IACA,YAAA;EAlER;EAqEM;IACE,aAAA;IACA,uBAAA;EAnER;EAqEQ;IACE,WAAA;IACA,kBAAA;IACA,YAAA;EAnEV;EAuEQ;IACE,WAAA;IACA,gBAAA;IACA,iBAAA;EArEV;EA0EI;IACE,aAAA;EAxEN;EA0EM;IACE,OAAA;IACA,YAAA;EAxER;AACF;AAgFE;EACE,YAAA;EACA,aAAA;AA9EJ;;AAgFE;EACE,mBAAA;AA7EJ;;AAiFE,wEAAA;AAEF;EACE,gCAAA,EAAA,wCAAA;EACA,6BAAA;AA/EF;;AAkFA;EACE,YAAA;EACA,YAAA;EACA,WAAA;EACA,OAAA;AA/EF;;AAmFA,yCAAA;AAEA;EACE,UAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;AAjFF;;AAmFA;EACE,kBAAA;EACA,iBAAA;AAhFF;;AAkFA;EACE,mBAAA;EACA,YAAA;EACA,WAAA;AA/EF;;AAiFA;EACE,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,mCAAA;EACA,2BAAA;EACA,UAAA;AA9EF;;AAgFA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,SAAA;EACA,sBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,yBAAA;AA7EF;;AA+EA;EACE,eAAA;EACA,WAAA;AA5EF;;AA8EA;EACE,YAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,UAAA;AA3EF;;AA6EA;;EAEE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,sBAAA;AA1EF;;AA4EA;;EAEE,sBAAA;EACA,eAAA;EACA,kBAAA;AAzEF;;AA2EA;EACE,2BAAA;AAxEF;AAyEE;EACE,YAAA;EACA,WAAA;EACA,WAAA;EACA,qBAAA;AAvEJ;AAwEI;EACE,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;AAtEN;AAuEM;EACE,SAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,2BAAA;EACA,QAAA;EACA,WAAA;AArER;AAuEM;EAGE,WAAA;EACA,WAAA;EACA,OAAA;EACA,2BAAA;AAvER;;AA4EA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,sBAAA;EACA,gBAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAzEF;;AA2EA;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,0BAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AAxEF;;AA0EA;EACE,8BAAA;EACA,kBAAA;AAvEF;;AAyEA;EACE,sBAAA;EACA,eAAA;EACA,kBAAA;AAtEF;;AAyEA,gBAAA;AACA;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,iBAAA;EACA,2BAAA;AAtEF;;AAwEA;EACE,WAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AArEF;;AAuEA;EACE,kBAAA;EACA,mBAAA;EACA,aAAA;EAEA,WAAA;EAEA,iBAAA;AAtEF;;AAwEA;EACE,gBAAA;EACA,iCAAA,EAAA,uBAAA;EACA,wBAAA;EACA,WAAA;EACA,oBAAA;AArEF;;AAuEA;EACE,oBAAA,EAAA,+BAAA;AApEF;;AAsEA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;AAnEF;;AAsEA;EACE,SAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,+CAAA;EACA,QAAA;EACA,WAAA;AAnEF;;AAqEA;EACE,0BAAA;AAlEF;;AAqEA;EACE;IACE,wBAAA;IACA,yBAAA;IACA,qBAAA;IACA,oBAAA;IACA,iBAAA;EAlEF;EAoEA;IACE,8BAAA;IACA,gBAAA;IACA,4BAAA;IACA,aAAA;IACA,WAAA;IACA,yBAAA;EAlEF;EAoEA;IACE,2BAAA;IACA,kBAAA;EAlEF;EAoEA;IACE,8BAAA;IACA,2BAAA;IACA,WAAA;IACA,eAAA;IACA,iBAAA;IACA,0BAAA;IACA,iCAAA;IACA,2BAAA;IACA,wBAAA;IACA,mBAAA;EAlEF;AACF;AAsEA;EACE,UAAA;EAEA,kBAAA;EACA,aAAA;EACA,8BAAA;AArEF;AAsEE;EACE,mBAAA;EACA,YAAA;EACA,WAAA;AApEJ;AAsEE;EACE,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,UAAA;EACA,2BAAA;EACA,UAAA;AApEJ;AAqEI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,SAAA;EACA,sBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,yBAAA;AAnEN;AAqEI;EACE,2BAAA;AAnEN;AAoEM;EACE,YAAA;EACA,WAAA;EACA,WAAA;EACA,qBAAA;AAlER;AAmEQ;EACE,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;AAjEV;AAkEU;EACE,SAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,2BAAA;EACA,QAAA;EACA,WAAA;AAhEZ;AAkEU;EAGE,WAAA;EACA,WAAA;EACA,OAAA;EACA,2BAAA;AAlEZ;;AAyEA;EACE,kBAAA;EACA,aAAA;AAtEF;;AAyEA;EACE,eAAA;EACA,WAAA;AAtEF;;AAwEA;EACE,YAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,UAAA;AArEF;;AAuEA;;EAEE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,sBAAA;AApEF;;AAsEA;;EAEE,sBAAA;EACA,eAAA;EACA,kBAAA;AAnEF;;AAsEA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,sBAAA;EACA,gBAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAnEF;;AAqEA;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,0BAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AAlEF;;AAoEA;EACE,8BAAA;EACA,kBAAA;AAjEF;;AAmEA;EACE,sBAAA;EACA,eAAA;EACA,kBAAA;AAhEF;;AAmEA,gBAAA;AACA;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,iBAAA;EACA,2BAAA;AAhEF;;AAkEA;EACE,WAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AA/DF;;AAiEA;EACE,kBAAA;EACA,mBAAA;EACA,aAAA;EAEA,WAAA;EAEA,iBAAA;AAhEF;;AAkEA;EACE,gBAAA;EACA,iCAAA,EAAA,uBAAA;EACA,wBAAA;EACA,WAAA;EACA,oBAAA;AA/DF;AAgEE;EACE,oBAAA,EAAA,+BAAA;AA9DJ;;AAkEA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;AA/DF;;AAkEA;EACE,SAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,+CAAA;EACA,QAAA;EACA,WAAA;AA/DF;;AAiEA;EACE,0BAAA;AA9DF;;AAiEA;EACE;IACE,wBAAA;IACA,yBAAA;IACA,qBAAA;IACA,oBAAA;IACA,iBAAA;EA9DF;EAgEA;IACE,8BAAA;IACA,gBAAA;IACA,4BAAA;IACA,aAAA;IACA,WAAA;IACA,yBAAA;EA9DF;EAgEA;IACE,2BAAA;IACA,kBAAA;EA9DF;EAgEA;IACE,8BAAA;IACA,2BAAA;IACA,WAAA;IACA,eAAA;IACA,iBAAA;IACA,0BAAA;IACA,iCAAA;IACA,2BAAA;IACA,wBAAA;IACA,mBAAA;EA9DF;EAgEA;IACE,WAAA;IACA,eAAA;IACA,yCAAA;IACA,sDAAA;IACA,kBAAA;IACA,WAAA;IACA,4BAAA;IACA,yBAAA;IACA,aAAA;EA9DF;EAgEA;IACE,SAAA;IACA,4BAAA;EA9DF;EAgEA;IACE,WAAA;IACA,SAAA;EA9DF;EAgEA;IACE,YAAA;EA9DF;EAgEA;IACE,WAAA;IACA,yCAAA;IACA,YAAA;EA9DF;EAgEA;IACE,aAAA;EA9DF;EAgEA;IACE,aAAA;EA9DF;EAgEA;IACE,2BAAA;EA9DF;EAgEA;IACE,aAAA;EA9DF;EAgEA;IACE,aAAA;EA9DF;AACF;AAiEA;EACE,qBAAA;EACA,uBAAA;EACA,iBAAA;EACA,sBAAA;AA/DF;;AAkEA;EACE,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;EACA,sBAAA;AA/DF;;AAmEA;EACE,aAAA;EACA,mBAAA;AAhEF;AAkEE;EACE,cAAA;EACA,uBAAA;EACA,2BAAA;EACA,kCAAA;EACA,qBAAA;EACA,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;AAhEJ;AAkEI;EACE,oDAAA;AAhEN;AAmEI;EACE,wBAAA;EACA,qDAAA;AAjEN;AAoEI;EACE,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,4BAAA;AAlEN;;AAwEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AArEF;AAuEE;EACE,kBAAA;EACA,kBAAA;AArEJ;AAuEI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;AArEN;AAwEI;EACE,iBAAA;EACA,WAAA;AAtEN;AAyEI;EACE,SAAA;EACA,WAAA;AAvEN;AA2EE;EACE,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,4CAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;AAzEJ;AA2EI;EACE,6CAAA;AAzEN;AA4EI;EACE,aAAA;AA1EN;AA6EI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;AA3EN;AA6EM;EACE,SAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,OAAA;AA3ER;AA8EM;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;AA5ER;AAiFM;EACE,mBAAA;AA/ER;AAiFQ;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,kBAAA;AA/EV;AAkFQ;EACE,SAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAhFV;AAmFQ;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,qBAAA;AAjFV;AAmFU;EACE,0BAAA;AAjFZ;;AAyFA;EAEI;IACE,mBAAA;EAvFJ;EAyFI;IACE,aAAA;EAvFN;EA0FI;IACE,sBAAA;IACA,uBAAA;IACA,SAAA;EAxFN;AACF;AAiGE;;;;;;;;;;EAUE,8BAAA;EACA,oCAAA;EACA,yBAAA;EACA,kDAAA;AA/FJ;AAkGE;EACE,yBAAA;EACA,cAAA;EACA,sCAAA;AAhGJ;AAmGE;EACE,8BAAA;EACA,oCAAA;EACA,yBAAA;EACA,kDAAA;AAjGJ;AAmGE;EACE,8BAAA;EACA,oCAAA;EACA,yBAAA;EACA,kDAAA;AAjGJ;AAmGE;EAAiB,8BAAA;AAhGnB;AAiGE;;EAEE,8BAAA;AA/FJ;AAgGI;;EAAK,yBAAA;AA5FT;AA+FE;EACE,8BAAA;EACA,kDAAA;EACA,yBAAA;AA7FJ;AAgGE;EACE,yBAAA;AA9FJ;AAiGE;EACE,8BAAA;AA/FJ;AAgGI;EACE,8BAAA;EACA,kDAAA;AA9FN;AAmGE;EACE,8BAAA;EACA,kDAAA;AAjGJ;AAkGI;EAAqB,yBAAA;AA/FzB;AAgGI;EAAgB,yBAAA;AA7FpB;AA8FI;EAAoB,yBAAA;AA3FxB;AA4FI;EAAqB,8BAAA;EAAgC,yBAAA;AAxFzD;AA4FE;;;;;EAKE,oFAAA;EACA,qCAAA;AA1FJ;;AAoGA;;EAEE,mCAAA;EACA,8BAAA;AAjGF;;AAoGA;;;;;;;;;;;;EAYE,oCAAA;EACA,8BAAA;EACA,yCAAA;AAjGF;;AAoGA;;;;;EAKE,mCAAA;EACA,8BAAA;EACA,yCAAA;AAjGF;;AAoGA;EACE,wCAAA;EACA,8BAAA;EACA,yCAAA;AAjGF;;AAoGA;EACE,yCAAA;AAjGF;;AAoGA;;;EAGE,8BAAA;EACA,8BAAA;EACA,yCAAA;AAjGF;;AAoGA;EACE,mCAAA;EACA,8BAAA;AAjGF;;AAoGA;EACE,oCAAA;EACA,8BAAA;EACA,yCAAA;AAjGF;;AAoGA;EACE,qCAAA;EACA,6BAAA;AAjGF;;AAoGA;;;;;;;;;EASE,8BAAA;AAjGF;;AAoGA;EACE,8BAAA;AAjGF;;AAmGA,6FAAA;AACA;EACE,8BAAA;EACA,oCAAA;EACA,iDAAA;EACA,oDAAA;AAhGF;;AAkGA;EACE,8BAAA;EACA,oCAAA;AA/FF;;AAiGA;EACE,oCAAA;EACA,8BAAA;EACA,yBAAA;EACA,yDAAA;EACA,wDAAA;AA9FF;;AAgGA;EACE,oCAAA;EACA,yBAAA;EACA,sDAAA;EACA,uDAAA;AA7FF;;AA+FA;EACE,oCAAA;AA5FF;;AA8FA;EACE,oCAAA;EACA,yBAAA;EACA,iDAAA;AA3FF;;AA6FA;EACE,8BAAA;EACA,oCAAA;EACA,iDAAA;AA1FF;;AA4FA;EACE,yBAAA;AAzFF;;AA2FA;;EAEE,8BAAA;EACA,oCAAA;EACA,yBAAA;EACA,iDAAA;AAxFF;;AA2FA,gDAAA;AACA;EACE,8BAAA;EACA,oCAAA;AAxFF;;AA0FA;;EAEE,mBAAA;EACA,UAAA;EACA,WAAA;AAvFF;;AAyFA;;EAEE,mBAAA;EACA,kBAAA;AAtFF;;AAwFA;;EAEE,mBAAA;EACA,kBAAA;AArFF;;AAuFA;;EAEE,mBAAA;AApFF;;AAsFA;;EAEE,mBAAA;AAnFF;;AAsFA,sCAAA;AACA;EACE,8BAAA;EACA,yBAAA;EACA,iDAAA;AAnFF","sourcesContent":[".big-box {\n    border: 2px solid #333;\n    padding: 20px;\n    background-color: #f0f0f0;\n    border-radius: 10px;\n    box-shadow: 2px 2px 5px #888;\n    text-align: center;\n  }\n  \n  body {\n    overflow-x: hidden;\n  }\n  \n  .logo {\n    width: 100px;\n    margin-right: 100px;\n  }\n  \n  .top-menu-wrap {\n    display: flex;\n    align-items: center;\n    padding: 20px 10px;\n  }\n  \n  .user-name {\n    display: flex;\n    align-items: center;\n  }\n  \n  .user-details {\n    flex: 1;\n    display: flex;\n    justify-content: flex-end;\n  }\n  \n  .user-name p {\n    display: flex;\n    align-items: center;\n  }\n  \n  .user-name span {\n    width: 40px;\n    height: 40px;\n    background: red;\n    border-radius: 50%;\n    display: block;\n    margin-right: 10px;\n  }\n  \n  .dashbored-wrap {\n    display: flex;\n    width: 100%;\n    height: 100vh;\n    background: var(--fc-bg, #fff);\n    /* background: red; */\n  }\n  \n  .top-menu-wrap {\n    width: 100%;\n    height: 100px;\n  \n    background: var(--fc-bg, #fff);\n  }\n  \n  .dash-details {\n    width: 100%;\n    display: flex;\n    max-height: 100vh;\n  \n    /* background: green; */\n  }\n  \n  .detail-list {\n    max-width: 250px;\n    width: 100%;\n    padding: 20px 10px;\n    background-color: #efeeee;\n    color: #212529;\n    position: fixed;\n    top: calc(var(--app-header) + 24px);\n    height: calc(100vh - 120px);\n  }\n  \n  ul {\n    list-style: none;\n    padding: 0px;\n    margin: 0px;\n  }\n  \n  p {\n    margin-bottom: 10px;\n  }\n  \n  ul li {\n    margin-bottom: 10px;\n    height: 40px;\n  \n    padding: 0px 10px;\n    position: relative;\n    z-index: 1;\n    color: #212529;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    transition: width 0.3s ease 0s, left 0.3s ease 0s;\n  }\n  \n  ul li:before {\n    bottom: 0;\n    content: \"\";\n    display: block;\n    height: 100%;\n    left: 0px;\n    position: absolute;\n    background: #fff;\n    transition: width 0.3s ease 0s, left 0.3s ease 0s;\n    width: 0%;\n    z-index: -1;\n  }\n  \n  ul li:hover {\n    color: #000;\n  }\n  \n  ul li:hover:before {\n    /* background: #fff;\n      color: #212529; */\n    width: 100%;\n  }\n  \n  .table-bordered {\n    border: 0px;\n  }\n  \n  .detail-description {\n    /* width: 100%; */\n    height: 100%;\n    padding: 0px;\n    width: calc(100% - 250px);\n    height: 100%;\n    padding: 0px;\n    width: 100%;\n    // position: absolute;\n    left: 270px;\n    top: 120px;\n    /* background: purple; */\n  }\n  \n  .followers-tag {\n    display: flex;\n    position: relative;\n    z-index: 1;\n  }\n  \n  h3 {\n    position: relative;\n    z-index: 3;\n    color: #fff;\n    font-weight: normal;\n  }\n  \n  .com-record {\n    width: 100%;\n    height: auto;\n    position: relative;\n    z-index: 0;\n    padding: 20px 30px 30px;\n  \n    .followers-tag {\n      .box {\n        .text {\n          p.number {\n            font-family: Arial !important;\n          }\n        }\n      }\n    }\n  }\n  \n  .com-record:after {\n    content: \"\";\n    width: 100%;\n    height: 60%;\n    /* background: gray; */\n    top: 0px;\n    position: absolute;\n    left: 0px;\n    z-index: 0;\n    background: #5ea1d8;\n  }\n  \n  .ico-box {\n    width: 40px;\n    height: 40px;\n    background: cyan;\n  }\n  \n  .table-wrap {\n    padding: 30px;\n    /* width:calc(100% - 76px); */\n  }\n  \n  .box {\n    width: auto;\n    padding: 5px 10px;\n    background: #fff;\n    margin-right: 20px;\n    border: 1px solid #ddd;\n    border-radius: 10px;\n    display: flex;\n    box-shadow: 1px 1px 25px rgba(0, 0, 0, 0.1607843137);\n  }\n  \n  .filter-ico li {\n    width: 40px;\n  }\n  \n  .filter-ico li i {\n    color: #000;\n  }\n  \n  .text {\n    padding-right: 10px;\n  }\n  \n  .table-parent {\n    overflow-x: scroll;\n    margin-top: -8px;\n    // max-height: 400px;\n    overflow-y: auto;\n  }\n  \n  table {\n    margin-bottom: 20px;\n    border-collapse: collapse;\n    width: 100%;\n    background: white;\n    border-radius: 0 0 8px 8px;\n    overflow: hidden;\n  }\n  \n  th,\n  td {\n    border: none;\n    color: #333;\n    padding: 16px;\n    min-width: 100px;\n    font-family: \"Raleway\";\n    vertical-align: middle;\n  }\n  \n  th {\n    background-color: #f5f5f5;\n    font-weight: 600;\n    color: #333;\n    text-transform: uppercase;\n    font-size: 12px;\n    letter-spacing: 0.5px;\n    padding: 16px;\n    border-bottom: 2px solid #e0e0e0;\n  }\n  \n  td {\n    padding: 16px;\n    border-bottom: 1px solid #e0e0e0;\n    vertical-align: middle;\n  }\n  \n  td[scope=\"row\"] {\n    position: relative;\n  }\n  \n  .inner {\n    width: 100%;\n    margin-bottom: 0px;\n  \n    td {\n      padding: 5px;\n      border: 0px;\n  \n      &:first-child {\n        width: 30px;\n      }\n    }\n  }\n  \n  tbody tr {\n    cursor: pointer;\n    transition: background-color 0.2s;\n    &:first-child {\n      // display: flex;\n    }\n  \n    &:hover {\n      background-color: #f9f9f9;\n  \n      td {\n        color: #333;\n      }\n    }\n    &:last-child td {\n      border-bottom: none;\n    }\n  }\n  \n  // tr:nth-child(even){\n  //     background: #5ea1d8;\n  \n  // }\n  // tr:nth-child(even) td{\n  //     color: #fff;\n  // }\n  \n  .filter {\n    display: flex;\n    align-items: center;\n    margin-bottom: 0px;\n    border: 1px solid #ddd;\n    border-bottom: 0px;\n    padding: 10px 10px;\n  }\n  \n  .filter-title {\n    flex: 1;\n  }\n  \n  .filter ul {\n    display: flex;\n  }\n  \n  .filter-bar {\n    display: flex;\n  }\n  \n  .search-container {\n    position: relative;\n  }\n  \n  .search-input {\n    width: 400px;\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    position: relative;\n  }\n  \n  .search-input+i {\n    position: absolute;\n    right: 20px;\n    top: 37%;\n  }\n  \n  .search-icon {\n    position: absolute;\n    top: 50%;\n    right: 10px;\n    transform: translateY(-50%);\n  }\n  \n  .chekbox-image {\n    display: flex;\n  \n    td {\n      &:first-child {\n        width: unset;\n        flex: 1;\n        min-width: 150px;\n        display: flex;\n        align-items: flex-start;\n  \n        span {\n          padding-left: 13px;\n        }\n      }\n  \n      &:last-child {\n        min-width: unset;\n        width: 40px;\n        display: flex;\n        align-items: flex-start;\n      }\n    }\n  }\n  \n  .image-sec {\n    img {\n      max-width: 100%;\n      max-height: 80px;\n      width: 100%;\n      object-fit: cover;\n    }\n  }\n  \n  .bundel {\n    span {\n      img {}\n    }\n  }\n  \n  .mobile-design {\n    display: none;\n  }\n  \n  @media(max-width:992px) {\n    .detail-list {\n      display: none;\n    }\n  \n    .detail-description {\n      width: 100%;\n      left:0px;\n      padding: 0px 15px;\n    }\n  \n    .followers-tag {\n      flex-wrap: wrap;\n  \n      .box {\n        margin: 10px;\n        width: 100%;\n  \n        .text {\n          flex: 1;\n        }\n      }\n    }\n  \n    .com-record {\n      padding: 15px;\n  \n      &:after {\n        height: 130px;\n      }\n    }\n  \n    .filter {\n      // display: none;\n    }\n  \n    .search-container {\n      .search-input {\n        width: 100%;\n      }\n    }\n  \n    .top-menu-wrap {\n      display: none;\n    }\n  \n    .table-wrap {\n      .table-parent {\n        display: none;\n      }\n    }\n  \n    .mobile-design {\n      padding: 20px 10px;\n      background: lightblue;\n      display: block;\n  \n      .tile {\n        background: #fff;\n        padding: 10px;\n  \n        &>div {\n          border-bottom: 1px solid #ddd;\n        }\n  \n        p {\n          color: #5ea1d8 !important;\n        }\n  \n        p.bold {\n          font-weight: 700 !important;\n          font-family: Arial, Helvetica, sans-serif !important;\n        }\n  \n        .main-title {\n          display: flex;\n          align-items: center;\n          background: #5ea1d8;\n          padding: 10px;\n          margin-bottom: 10px;\n  \n          h3 {\n            margin-bottom: 0px !important;\n            color: #fff !important;\n          }\n        }\n  \n      }\n  \n      .first-tile {\n        div {\n          display: flex;\n          align-items: center;\n          margin-bottom: 10px;\n  \n          span {\n            display: flex;\n            align-items: center;\n          }\n        }\n  \n        input {\n          position: relative;\n          margin: 0px 10px 0px 0px;\n          width: 20px;\n          height: 20px;\n        }\n  \n        .img {\n          display: flex;\n          align-items: flex-start;\n  \n          .bundle {\n            width: 30px;\n            margin-right: 10px;\n            height: 30px;\n  \n          }\n  \n          img {\n            width: 100%;\n            max-height: 80px;\n            object-fit: cover;\n          }\n        }\n      }\n  \n      .common-tile {\n        display: flex;\n  \n        .title-tile {\n          flex: 1;\n          padding: 3px;\n  \n        }\n      }\n  \n  \n    }\n  }\n  \n  .pie-chart-canvas {\n    width: 400px;\n    height: 400px;\n  }\n  .mat-mdc-tab-list{\n    margin-bottom: 10px;\n  }\n\n\n  /* Assuming each chart component has a class name of 'chart-container' */\n\n.row { \n  grid-template-columns: auto auto; /* Use flexbox to align items in a row */\n  overflow-x: hidden !important; \n   \n}\n.chart-container {\n  margin: 15px;\n  height: 25vh;\n  width: 50vh;\n  flex:1;\n}\n\n\n/* new setting common design starts here*/\n\n.setting-dashboard {\n  padding: 0;\n  height: auto;\n  position: relative;\n  margin-top: 0;\n  background: var(--fc-bg, #fff);\n}\n.dashbored-wrap{\n  padding-left: 10px;\n  margin-top:5  0px;\n}\n.setting-dashboard .row {\n  flex-direction: row;\n  height: 100%;\n  margin: 0px;\n}\n.setting-dashboard .left-user {\n  background: #5ea1d8;\n  position: relative;\n  padding: 0 0 0 30px;\n  position: fixed;\n  top: calc(var(--app-header) + 24px);\n  height: calc(100vh - 100px);\n  z-index: 3;\n}\n.collapse-btn {\n  position: absolute;\n  width: 25px;\n  height: 25px;\n  background: #5ea1d8;\n  border-radius: 50%;\n  right: -12.5px;\n  top: 26px;\n  border: 2px solid #fff;\n  box-shadow: 0 0 3px #171717;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  transform: rotate(180deg);\n}\n.setting-dashboard .left-user .dash-title {\n  position: unset;\n  width: 100%;\n}\n.setting-dashboard .dash-title {\n  height: 80px;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  color: #fff;\n  position: fixed;\n  z-index: 2;\n  top:120px;\n}\n.setting-dashboard .dash-title h6,\n.setting-dashboard .dash-title .h6 {\n  display: flex;\n  align-items: center;\n  font-weight: 500 !important;\n  color: #fff !important;\n}\n.setting-dashboard .dash-title h6 span,\n.setting-dashboard .dash-title .h6 span {\n  width: auto !important;\n  font-size: 20px;\n  margin-right: 10px;\n}\n.setting-dashboard.search-add .dash-elemenet {\n  height: calc(100vh - 180px);\n  ul {\n    padding: 0px;\n    margin: 0px;\n    width: 100%;\n    list-style-type: none;\n    li {\n      height: 40px;\n      margin-bottom: 10px;\n      position: relative;\n      display: flex;\n      align-items: center;\n      transition: all 0.5s linear;\n      padding-left: 10px;\n      &:after {\n        bottom: 0;\n        content: \"\";\n        display: block;\n        height: 1px;\n        height: 100%;\n        left: 0%;\n        position: absolute;\n        background: #fff;\n        background: #1d67a3;\n        transition: all 0.5s linear;\n        width: 0;\n        z-index: -1;\n      }\n      &:hover:after,\n      &:active:after,\n      &:focus:after {\n        content: \"\";\n        width: 100%;\n        left: 0;\n        transition: all 0.5s linear;\n      }\n    }\n  }\n}\n.setting-dashboard .dash-elemenet {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex-direction: column;\n  margin-top: 1rem;\n  height: calc(100vh - 220px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding-right: 20px;\n}\n.setting-dashboard .dash-elemenet > div {\n  width: 100%;\n  line-height: 26px;\n  margin-bottom: 10px;\n  font-size: 13px;\n  font-weight: 400;\n  cursor: pointer;\n  color: #fff;\n  transition: all 0.5slinear;\n  position: relative;\n  padding-bottom: 0;\n  z-index: 2;\n  min-height: 40px;\n  display: flex;\n  align-items: center;\n}\n.left-user .selected-item {\n  background: #1d67a3 !important;\n  padding-left: 10px;\n}\n.setting-dashboard .left-user .dash-elemenet > div span {\n  width: auto !important;\n  font-size: 20px;\n  margin-right: 10px;\n}\n\n/*right section*/\n.setting-dashboard .submission-field {\n  left: 16.666667%;\n  padding-right: 0;\n  position: fixed;\n  position: absolute;\n  top: 0px;\n  width: 83.333333%;\n  padding-left: 0px;\n  border-left: 1px solid #fff;\n}\n.setting-dashboard .submission-field .hamburger {\n  width: 100%;\n  background: #985ce1;\n  display: flex;\n  position: relative;\n}\n.setting-dashboard .submission-field .hamburger .dash-title {\n  padding-left: 15px;\n  background: #5ea1d8;\n  display: flex;\n  // border-left: 1px solid #fff;\n  color: #fff;\n  // left: 16.666667%;\n  width: 83.333333%;\n}\n.scroll-div {\n  position: sticky;\n  top: var(--app-header) !important; /* match landing page */\n  margin-top: 0 !important;\n  width: 100%;\n  padding-bottom: 20px;\n}\n.scroll-div .dash-text {\n  padding: 10px 15px 0; /* match landing page padding */\n}\n.mat-mdc-tab-group {\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n}\n\n.setting-dashboard .dash-elemenet > div:after {\n  bottom: 0;\n  content: \"\";\n  display: block;\n  height: 1px;\n  height: 100%;\n  left: 0%;\n  position: absolute;\n  background: #fff;\n  background: #6322b2;\n  transition: width 0.5sease 0s, left 0.5sease 0s;\n  width: 0;\n  z-index: -1;\n}\n.setting-dashboard .dash-elemenet > div span:last-child {\n  font-size: 12px !important;\n}\n\n@media (max-width: 767px) {\n  .scroll-div {\n    margin-top: 0 !important;\n    padding-top: 0 !important;\n    padding: 0 !important;\n    margin: 0 !important;\n    top: 0 !important;\n  }\n  .mob-menu {\n    background: #5d9fd5 !important;\n    position: sticky;\n    top: var(--app-header, 56px);\n    z-index: 1500;\n    width: 100%;\n    display: block !important;\n  }\n  .navbar {\n    justify-content: flex-start;\n    margin-bottom: 0px;\n  }\n  .mob-menu button {\n    background: #5d9fd5 !important;\n    margin-bottom: 0 !important;\n    color: #fff;\n    font-size: 14px;\n    padding: 10px 5px;\n    text-transform: capitalize;\n    border: 1px solid #fff !important;\n    box-shadow: none !important;\n    display: flex !important;\n    align-items: center;\n  }\n}\n\n\n.setting-dashboard {\n  padding: 0;\n  // height: 100vh;\n  position: relative;\n  margin-top: 0;\n  background: var(--fc-bg, #fff);\n  .row {\n    flex-direction: row;\n    height: 100%;\n    margin: 0px;\n  }\n  .left-user {\n    background: #5ea1d8;\n    position: relative;\n    padding: 0 0 0 30px;\n    position: fixed;\n    top: 120px;\n    height: calc(100vh - 100px);\n    z-index: 3;\n    .collapse-btn {\n      position: absolute;\n      width: 25px;\n      height: 25px;\n      background: #5ea1d8;\n      border-radius: 50%;\n      right: -12.5px;\n      top: 26px;\n      border: 2px solid #fff;\n      box-shadow: 0 0 3px #171717;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      color: #fff;\n      transform: rotate(180deg);\n    }\n    .dash-elemenet {\n      height: calc(100vh - 180px);\n      ul {\n        padding: 0px;\n        margin: 0px;\n        width: 100%;\n        list-style-type: none;\n        li {\n          height: 40px;\n          margin-bottom: 10px;\n          position: relative;\n          display: flex;\n          align-items: center;\n          transition: all 0.5s linear;\n          padding-left: 10px;\n          &:after {\n            bottom: 0;\n            content: \"\";\n            display: block;\n            height: 1px;\n            height: 100%;\n            left: 0%;\n            position: absolute;\n            background: #fff;\n            background: #1d67a3;\n            transition: all 0.5s linear;\n            width: 0;\n            z-index: -1;\n          }\n          &:hover:after,\n          &:active:after,\n          &:focus:after {\n            content: \"\";\n            width: 100%;\n            left: 0;\n            transition: all 0.5s linear;\n          }\n        }\n      }\n    }\n  }\n}\n.dashbored-wrap {\n  padding-left: 10px;\n  margin-top: 0;\n}\n \n.setting-dashboard .left-user .dash-title {\n  position: unset;\n  width: 100%;\n}\n.setting-dashboard .dash-title {\n  height: 80px;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  color: #fff;\n  position: fixed;\n  z-index: 2;\n  top: 120px;\n}\n.setting-dashboard .dash-title h6,\n.setting-dashboard .dash-title .h6 {\n  display: flex;\n  align-items: center;\n  font-weight: 500 !important;\n  color: #fff !important;\n}\n.setting-dashboard .dash-title h6 span,\n.setting-dashboard .dash-title .h6 span {\n  width: auto !important;\n  font-size: 20px;\n  margin-right: 10px;\n}\n \n.setting-dashboard .dash-elemenet {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex-direction: column;\n  margin-top: 1rem;\n  height: calc(100vh - 220px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding-right: 20px;\n}\n.setting-dashboard .dash-elemenet > div {\n  width: 100%;\n  line-height: 26px;\n  margin-bottom: 10px;\n  font-size: 13px;\n  font-weight: 400;\n  cursor: pointer;\n  color: #fff;\n  transition: all 0.5slinear;\n  position: relative;\n  padding-bottom: 0;\n  z-index: 2;\n  min-height: 40px;\n  display: flex;\n  align-items: center;\n}\n.left-user .selected-item {\n  background: #1d67a3 !important;\n  padding-left: 10px;\n}\n.setting-dashboard .left-user .dash-elemenet > div span {\n  width: auto !important;\n  font-size: 20px;\n  margin-right: 10px;\n}\n \n/*right section*/\n.setting-dashboard .submission-field {\n  left: 16.666667%;\n  padding-right: 0;\n  position: fixed;\n  position: absolute;\n  top: 0px;\n  width: 83.333333%;\n  padding-left: 0px;\n  border-left: 1px solid #fff;\n}\n.setting-dashboard .submission-field .hamburger {\n  width: 100%;\n  background: #985ce1;\n  display: flex;\n  position: relative;\n}\n.setting-dashboard .submission-field .hamburger .dash-title {\n  padding-left: 15px;\n  background: #5ea1d8;\n  display: flex;\n  // border-left: 1px solid #fff;\n  color: #fff;\n  // left: 16.666667%;\n  width: 83.333333%;\n}\n.scroll-div {\n  position: sticky;\n  top: var(--app-header) !important; /* match landing page */\n  margin-top: 0 !important;\n  width: 100%;\n  padding-bottom: 20px;\n  .dash-text {\n    padding: 10px 15px 0; /* match landing page padding */\n  }\n}\n \n.mat-mdc-tab-group {\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n}\n \n.setting-dashboard .dash-elemenet > div:after {\n  bottom: 0;\n  content: \"\";\n  display: block;\n  height: 1px;\n  height: 100%;\n  left: 0%;\n  position: absolute;\n  background: #fff;\n  background: #6322b2;\n  transition: width 0.5sease 0s, left 0.5sease 0s;\n  width: 0;\n  z-index: -1;\n}\n.setting-dashboard .dash-elemenet > div span:last-child {\n  font-size: 12px !important;\n}\n \n@media (max-width: 767px) {\n  .scroll-div {\n    margin-top: 0 !important;\n    padding-top: 0 !important;\n    padding: 0 !important;\n    margin: 0 !important;\n    top: 0 !important;\n  }\n  .mob-menu {\n    background: #5d9fd5 !important;\n    position: sticky;\n    top: var(--app-header, 56px);\n    z-index: 1500;\n    width: 100%;\n    display: block !important;\n  }\n  .navbar {\n    justify-content: flex-start;\n    margin-bottom: 0px;\n  }\n  .mob-menu button {\n    background: #5d9fd5 !important;\n    margin-bottom: 0 !important;\n    color: #fff;\n    font-size: 14px;\n    padding: 10px 5px;\n    text-transform: capitalize;\n    border: 1px solid #fff !important;\n    box-shadow: none !important;\n    display: flex !important;\n    align-items: center;\n  }\n  .setting-dashboard .left-user {\n    width: 59vw;\n    position: fixed;\n    top: calc(var(--app-header, 56px) + 48px);\n    height: calc(100vh - (var(--app-header, 56px) + 48px));\n    padding-left: 10px;\n    left: -59vw;\n    transition: left 0.5s linear;\n    display: block !important;\n    z-index: 1600;\n  }\n  .setting-dashboard .show-menu .left-user {\n    left: 0px;\n    transition: left 0.5s linear;\n  }\n  .setting-dashboard .submission-field {\n    width: 100%;\n    left: 0px;\n  }\n  .dashbored-wrap .table-wrap {\n    padding: 0px;\n  }\n  .setting-dashboard .submission-field .hamburger .dash-title {\n    width: 100%;\n    top: calc(var(--app-header, 56px) + 48px);\n    height: 40px;\n  }\n  .setting-dashboard .left-user .dash-title{\n    display: none;\n  }\n  .setting-dashboard .left-user .collapse-btn{\n    display: none;\n  }\n  .dashbored-wrap {\n    margin-top: 10px !important;\n  }\n  .dashbored-wrap .mobile-design{\n    padding: 20px;\n  }\n  .dashbored-wrap .com-record:after{\n    height: 133px;\n  }\n}\n\nlabel[for=\"timePeriod\"] {\n  display: inline-block;\n  margin: 16px 8px 16px 0;\n  line-height: 40px;\n  vertical-align: middle;\n}\n\n#timePeriod {\n  height: 40px;\n  min-width: 160px;\n  box-sizing: border-box;\n  margin: 16px 0;\n  padding: 0 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  background-color: #fff;\n  font: inherit;\n  font-size: 14px;\n  color: #333;\n  vertical-align: middle;\n}\n\n// View Toggle Styles (match Flow Reviews circular icon)\n.view-toggle {\n  display: flex;\n  align-items: center;\n\n  button {\n    color: #5ea1d8;\n    border: none !important;\n    box-shadow: none !important;\n    background: transparent !important;\n    padding: 0 !important;\n    width: 40px !important;\n    height: 40px !important;\n    min-width: 40px !important;\n    min-height: 40px !important;\n    border-radius: 50% !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n\n    &:hover {\n      background-color: rgba(94, 161, 216, 0.1) !important;\n    }\n\n    &:focus {\n      outline: none !important;\n      background-color: rgba(94, 161, 216, 0.18) !important;\n    }\n\n    mat-icon {\n      font-size: 22px !important;\n      width: 22px !important;\n      height: 22px !important;\n      line-height: 22px !important;\n    }\n  }\n}\n\n// Card View Styles for Links\n.links-list-card {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  margin-top: 20px;\n\n  .no-links {\n    text-align: center;\n    padding: 60px 20px;\n\n    mat-icon {\n      font-size: 64px;\n      width: 64px;\n      height: 64px;\n      color: #ccc;\n      margin-bottom: 16px;\n    }\n\n    h3 {\n      margin: 0 0 8px 0;\n      color: #666;\n    }\n\n    p {\n      margin: 0;\n      color: #999;\n    }\n  }\n\n  .link-card-modern {\n    background-color: #fff;\n    border-radius: 16px;\n    border: 1px solid #e2e8f0;\n    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);\n    overflow: hidden;\n    transition: all 0.3s ease;\n    box-sizing: border-box;\n\n    &:hover {\n      box-shadow: 0 4px 12px rgba(15, 23, 42, 0.12);\n    }\n\n    .card-content {\n      padding: 24px;\n    }\n\n    .link-header-modern {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      margin-bottom: 16px;\n      gap: 16px;\n\n      .link-title-modern {\n        margin: 0;\n        font-weight: 700;\n        font-size: 18px;\n        color: #0f172a;\n        flex: 1;\n      }\n\n      .click-count-badge {\n        display: inline-flex;\n        align-items: center;\n        padding: 6px 12px;\n        border-radius: 9999px;\n        font-size: 12px;\n        font-weight: 600;\n        background-color: #dbeafe;\n        color: #2563eb;\n        white-space: nowrap;\n      }\n    }\n\n    .link-content-modern {\n      .link-field {\n        margin-bottom: 16px;\n\n        label {\n          display: block;\n          font-size: 12px;\n          font-weight: 600;\n          text-transform: uppercase;\n          letter-spacing: 0.1em;\n          color: #94a3b8;\n          margin-bottom: 8px;\n        }\n\n        p {\n          margin: 0;\n          color: #334155;\n          line-height: 1.6;\n          font-size: 15px;\n        }\n\n        .link-url-modern {\n          color: #5ea1d8;\n          text-decoration: none;\n          font-weight: 500;\n          word-break: break-all;\n\n          &:hover {\n            text-decoration: underline;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .links-list-card {\n    .link-card-modern {\n      border-radius: 12px;\n\n      .card-content {\n        padding: 16px;\n      }\n\n      .link-header-modern {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 12px;\n      }\n    }\n  }\n}\n \n// ==============================================\n// DARK MODE\n// ==============================================\n:host-context(body.theme-dark) {\n  .dashbored-wrap,\n  .setting-dashboard,\n  .scroll-div,\n  .com-record,\n  .table-wrap,\n  .filter,\n  .search-input,\n  .detail-list,\n  .detail-description,\n  .big-box {\n    background: #111827 !important;\n    background-color: #111827 !important;\n    color: #e5e7eb !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n  }\n\n  #timePeriod {\n    background-color: #0f172a;\n    color: #e5e7eb;\n    border-color: rgba(148, 163, 184, 0.3);\n  }\n\n  table, thead, tbody, tr, td {\n    background: #111827 !important;\n    background-color: #111827 !important;\n    color: #e5e7eb !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n  }\n  th {\n    background: #0f172a !important;\n    background-color: #0f172a !important;\n    color: #94a3b8 !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n  }\n  tbody tr:hover { background: #1f2937 !important; }\n  tbody tr.no-data-row,\n  tbody tr.no-data-row:hover {\n    background: #111827 !important;\n    td { color: #e5e7eb !important; }\n  }\n\n  .box {\n    background: #1f2937 !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n    color: #e5e7eb !important;\n  }\n\n  p, span:not(.material-icons):not(.status-badge-modern):not([class*=\"badge\"]):not([class*=\"status-\"]), label, li, h1, h2, h3, h4, h5, h6, i, b {\n    color: #e5e7eb !important;\n  }\n\n  .mobile-design {\n    background: #0f172a !important;\n    .tile {\n      background: #1f2937 !important;\n      border-color: rgba(148, 163, 184, 0.25) !important;\n    }\n  }\n\n  // Card view ? analytics link cards\n  .links-list-card .link-card-modern {\n    background: #1f2937 !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n    .link-title-modern { color: #f1f5f9 !important; }\n    .link-field p { color: #cbd5e1 !important; }\n    .link-field label { color: #64748b !important; }\n    .click-count-badge { background: #1e3a5f !important; color: #93c5fd !important; }\n  }\n\n  // Shimmer skeleton\n  .skeleton-text,\n  .skeleton-checkbox,\n  .skeleton-icon,\n  .skeleton-image,\n  .skeleton-price {\n    background: linear-gradient(90deg, #1f2937 25%, #374151 50%, #1f2937 75%) !important;\n    background-size: 200% 100% !important;\n  }\n}\n\n\n// ════════════════════════════════════════════════\n// DARK MODE – direct body.theme-dark rules\n// These compile to body.theme-dark .class[_ngcontent-xxx]\n// which reliably overrides all hardcoded whites.\n// ════════════════════════════════════════════════\nbody.theme-dark .dashbored-wrap,\nbody.theme-dark .setting-dashboard {\n  background: var(--fc-bg) !important;\n  color: var(--fc-fg) !important;\n}\n\nbody.theme-dark .dashbored-wrap .top-menu-wrap,\nbody.theme-dark .dashbored-wrap .box,\nbody.theme-dark .dashbored-wrap .card,\nbody.theme-dark .dashbored-wrap .mat-mdc-card,\nbody.theme-dark .dashbored-wrap .tile,\nbody.theme-dark .dashbored-wrap .com-record,\nbody.theme-dark .dashbored-wrap .table-wrap,\nbody.theme-dark .dashbored-wrap .detail-list,\nbody.theme-dark .dashbored-wrap .filter,\nbody.theme-dark .dashbored-wrap .search-input,\nbody.theme-dark .dashbored-wrap .tab-content,\nbody.theme-dark .dashbored-wrap .followers-tag .box {\n  background: var(--fc-bg2) !important;\n  color: var(--fc-fg) !important;\n  border-color: var(--fc-border) !important;\n}\n\nbody.theme-dark .dashbored-wrap table,\nbody.theme-dark .dashbored-wrap thead,\nbody.theme-dark .dashbored-wrap tbody,\nbody.theme-dark .dashbored-wrap tr,\nbody.theme-dark .dashbored-wrap td {\n  background: var(--fc-bg) !important;\n  color: var(--fc-fg) !important;\n  border-color: var(--fc-border) !important;\n}\n\nbody.theme-dark .dashbored-wrap th {\n  background: var(--fc-bg-head) !important;\n  color: var(--fc-fg) !important;\n  border-color: var(--fc-border) !important;\n}\n\nbody.theme-dark .dashbored-wrap tbody tr:hover {\n  background: var(--fc-bg-hover) !important;\n}\n\nbody.theme-dark .dashbored-wrap input,\nbody.theme-dark .dashbored-wrap select,\nbody.theme-dark .dashbored-wrap textarea {\n  background: #0f172a !important;\n  color: var(--fc-fg) !important;\n  border-color: var(--fc-border) !important;\n}\n\nbody.theme-dark .dashbored-wrap .mobile-design {\n  background: var(--fc-bg) !important;\n  color: var(--fc-fg) !important;\n}\n\nbody.theme-dark .dashbored-wrap .mobile-design .tile {\n  background: var(--fc-bg2) !important;\n  color: var(--fc-fg) !important;\n  border-color: var(--fc-border) !important;\n}\n\nbody.theme-dark .dashbored-wrap [class*=\"skeleton-\"] {\n  background: var(--fc-skel) !important;\n  color: transparent !important;\n}\n\nbody.theme-dark .dashbored-wrap p,\nbody.theme-dark .dashbored-wrap label,\nbody.theme-dark .dashbored-wrap li,\nbody.theme-dark .dashbored-wrap h1,\nbody.theme-dark .dashbored-wrap h2,\nbody.theme-dark .dashbored-wrap h3,\nbody.theme-dark .dashbored-wrap h4,\nbody.theme-dark .dashbored-wrap h5,\nbody.theme-dark .dashbored-wrap h6 {\n  color: var(--fc-fg) !important;\n}\n\nbody.theme-dark .dashbored-wrap span:not(.material-icons):not(.badge):not([class*=\"status\"]) {\n  color: var(--fc-fg) !important;\n}\n/* ── Override global white-background globals (.table-card, .fc-table, .filter-section) ── */\nbody.theme-dark .table-card {\n  background: #1f2937 !important;\n  background-color: #1f2937 !important;\n  border-color: rgba(148, 163, 184, 0.2) !important;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4) !important;\n}\nbody.theme-dark .fc-table {\n  background: #1f2937 !important;\n  background-color: #1f2937 !important;\n}\nbody.theme-dark .fc-table thead th {\n  background-color: #0f172a !important;\n  background: #0f172a !important;\n  color: #94a3b8 !important;\n  border-bottom-color: rgba(148, 163, 184, 0.25) !important;\n  border-right-color: rgba(148, 163, 184, 0.15) !important;\n}\nbody.theme-dark .fc-table tbody td {\n  background-color: #1f2937 !important;\n  color: #e2e8f0 !important;\n  border-top-color: rgba(148, 163, 184, 0.15) !important;\n  border-right-color: rgba(148, 163, 184, 0.1) !important;\n}\nbody.theme-dark .fc-table tbody tr:nth-child(even) td {\n  background-color: #253347 !important;\n}\nbody.theme-dark .fc-table tbody tr:hover td {\n  background-color: #374151 !important;\n  color: #f1f5f9 !important;\n  border-color: rgba(148, 163, 184, 0.3) !important;\n}\nbody.theme-dark .filter-section {\n  background: #1f2937 !important;\n  background-color: #1f2937 !important;\n  border-color: rgba(148, 163, 184, 0.2) !important;\n}\nbody.theme-dark .filter-section label {\n  color: #94a3b8 !important;\n}\nbody.theme-dark .filter-section select,\nbody.theme-dark .filter-section input {\n  background: #0f172a !important;\n  background-color: #0f172a !important;\n  color: #e2e8f0 !important;\n  border-color: rgba(148, 163, 184, 0.3) !important;\n}\n\n/* ── Dark scrollbars and overflow area fix ── */\nbody.theme-dark .table-parent {\n  background: #1f2937 !important;\n  background-color: #1f2937 !important;\n}\nbody.theme-dark .table-parent::-webkit-scrollbar,\nbody.theme-dark .table-card::-webkit-scrollbar {\n  background: #111827;\n  width: 6px;\n  height: 6px;\n}\nbody.theme-dark .table-parent::-webkit-scrollbar-track,\nbody.theme-dark .table-card::-webkit-scrollbar-track {\n  background: #1f2937;\n  border-radius: 4px;\n}\nbody.theme-dark .table-parent::-webkit-scrollbar-thumb,\nbody.theme-dark .table-card::-webkit-scrollbar-thumb {\n  background: #374151;\n  border-radius: 4px;\n}\nbody.theme-dark .table-parent::-webkit-scrollbar-thumb:hover,\nbody.theme-dark .table-card::-webkit-scrollbar-thumb:hover {\n  background: #4b5563;\n}\nbody.theme-dark .table-parent::-webkit-scrollbar-corner,\nbody.theme-dark .table-card::-webkit-scrollbar-corner {\n  background: #111827;\n}\n\n/* ── Click-count badge dark mode ── */\nbody.theme-dark .click-count-badge {\n  background: #1e3a5f !important;\n  color: #93c5fd !important;\n  border-color: rgba(147, 197, 253, 0.3) !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
